/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { FontFamilyButtonStyle, FontFamilyOption } from './styledContents';
import { CustomFontsType, FontFamilyButtonProps } from './lintEditorType';
import { CONSTANTS } from './constants';

export function CustomFontFamilySelector(props: FontFamilyButtonProps) {
  const { customFontList, fontName, onFontFamilyChange, editor, setEnableIcon, fontStyleValue } =
    props;
  const fontFamilyArray = CONSTANTS.LINT_FONT_LIST as CustomFontsType[];
  const defaultFontStyles = 'Lato';

  const lintFontList = [...customFontList, ...fontFamilyArray];
  const filteredFontList = lintFontList.filter(
    (item, index, self) =>
      self.findIndex((font) => font.name === item.name && font.fontStyle === item.fontStyle) ===
      index,
  );
  const sortedFontList = filteredFontList.sort((fontA, fontB) =>
    fontA.name.localeCompare(fontB.name),
  );

  let styleOfSelection = 'normal';
  if (editor?.isActive('italic')) {
    styleOfSelection = 'italic';
  }

  let selectedFontName: string | null | undefined;
  let matchedFont = sortedFontList.find(
    (font) => font.name === fontName && font.fontStyle === styleOfSelection,
  );
  if (!matchedFont) {
    matchedFont = sortedFontList.find(
      (font) => font.name === fontName && font.fontStyle === 'normal',
    );
  }

  if (matchedFont) {
    selectedFontName =
      fontStyleValue !== ''
        ? `${fontName}-${fontStyleValue}`
        : `${fontName}-${matchedFont.fontStyle}`;
  } else {
    selectedFontName = fontName;
  }
  if (setEnableIcon) {
    setEnableIcon(
      styleOfSelection === 'italic' &&
        (/-italic$/i.test(selectedFontName as string) ||
          (matchedFont && /-italic$/i.test(selectedFontName as string))),
    );
  }
  return (
    <FontFamilyButtonStyle
      value={selectedFontName ? selectedFontName : defaultFontStyles}
      aria-label='fontFamily'
      data-testid='font-family-select'
      onChange={(value: string) => {
        onFontFamilyChange(value);
      }}
      className='fontFamilySelect fontFamilyDropdown'
      render={() => {
        return (
          <div className='font-family-view'>
            {selectedFontName ? selectedFontName : defaultFontStyles}
          </div>
        );
      }}
    >
      {sortedFontList.map((font, index) => (
        <FontFamilyOption
          key={`${font.name + '_' + index}`}
          data-testid='font-family-select-option'
          value={`${font.name}${font.fontStyle ? '-' + font.fontStyle : ''}`}
        >
          <span title={font.name} data-toggle='tooltip' data-placement='right'>
            {font.name}
            {font.fontStyle ? ' - ' + font.fontStyle : ''}
          </span>
        </FontFamilyOption>
      ))}
    </FontFamilyButtonStyle>
  );
}
